import styled from 'styled-components';
import Lottie from 'lottie-react';

import { useTheme } from '../../../../../Context/ThemeContext';
import { useLanguage } from '../../../../../Context/LanguageContext';
import { lightTheme, darkTheme } from '../../../../../Styles/theme';
import { formatPhoneNumber } from '../../../../../Utils/phoneUtils';

import UserProfile from '../../../../../Component/Normal/UserProfile';
import SearchInput from '../../../../../View/Message/Model/SearchInput';
import CustomScrollbar from '../../../../Share/Normal/CustomScrollbar';

import DefaultProfile from '../../../../../image/DefaultProfile.png';
import { ReactComponent as InfiniteSvg } from '../../../../../image/Infinite.svg';
import LoadingAnimation from '../../../../../Animation/NewLoading.json';

export default function ExistingTransfereeView(props) {
  const {
    isSearchOpen,
    setIsSearchOpen,
    searchValue,
    setSearchValue,

    selectedTransferee,
    onClickTransfereeItem,
    filteredTransfereeList,
    isLoadingTransferees,
    TransfereeScrollRef,

    transferDays,
    transferSessions,
    handleTransferDaysChange,
    handleTransferSessionsChange,

    remainingDays,
    remainingSessions,
    isUnlimitedSessions,

    computeTransferEndDate,
    formatMembershipPeriod,
  } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t, languageMode } = useLanguage();

  return (
    <ExistingView $hasSelected={!!selectedTransferee} $isSearchOpen={isSearchOpen}>
      <SearchInputClickWrapper onClick={() => setIsSearchOpen(prev => !prev)}>
        <SearchInput value={searchValue} setValue={setSearchValue} placeholder={t('memberDetail.extensionModal.searchMember')} width={425} />
      </SearchInputClickWrapper>
      {(isSearchOpen || !selectedTransferee) ? (
        <RowUnitWrapper width='100%' gap='2px' style={{ marginBottom: '20px', height: '220px', alignItems: 'stretch' }}>
          <TransfereeListWrapper>
            {
              isLoadingTransferees &&
              <LoadingOverlay>
                <LottieWrapper>
                  <Lottie animationData={LoadingAnimation} loop />
                </LottieWrapper>
              </LoadingOverlay>
            }
            <TransfereeListScroll ref={TransfereeScrollRef}>
              {filteredTransfereeList.map((member) => {
                return (
                  <TransfereeListItem key={member.memberId} onClick={() => onClickTransfereeItem(member)}>
                    <MemberListProfileBox>
                      <UserProfile profile={member.profile || ''} defaultProfile={DefaultProfile} />
                    </MemberListProfileBox>
                    <ColumnUnitWrapper>
                      <TextWrapper width='250px'>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{member.name}</Text>
                      </TextWrapper>
                      <TextWrapper width='200px'>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='pointer' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{formatPhoneNumber(member.phone, member.countryCode, languageMode)}</Text>
                      </TextWrapper>
                    </ColumnUnitWrapper>
                  </TransfereeListItem>
                );
              })}
            </TransfereeListScroll>
          </TransfereeListWrapper>
          <CustomScrollbar
            direction='vertical'
            scrollRef={TransfereeScrollRef}
            thumbSize='auto'
            thumbThickness={2}
            trackOffset={0}
            showTrackAlways={false}
            trackColor='transparent'
            isColorLine={true} />
        </RowUnitWrapper>
      ) : (
        <ColumnUnitWrapper width='100%' gap='15px'>
          <ColumnUnitWrapper width='100%' gap='5px'>
            <ProfileWrapper>
              <ProfileBox>
                <UserProfile profile={selectedTransferee?.profile || ''} defaultProfile={DefaultProfile} />
              </ProfileBox>
              <TextWrapper width='100px'>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{selectedTransferee?.name || '-'}</Text>
              </TextWrapper>
              <TextWrapper width='200px'>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{selectedTransferee ? formatPhoneNumber(selectedTransferee.phone, selectedTransferee.countryCode, languageMode) : '-'}</Text>
              </TextWrapper>
            </ProfileWrapper>
            <RowUnitWrapper width='100%' gap='10px'>
              <TextWrapper width='150px'>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.assignModalHeldMembership')}</Text>
              </TextWrapper>
              <ColumnUnitWrapper width='265px'>
                <TextWrapper width='265px' height='21px'>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{selectedTransferee?.membershipName || '-'}</Text>
                </TextWrapper>
                <TextWrapper width='265px' height='21px'>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{formatMembershipPeriod(selectedTransferee?.startDate, selectedTransferee?.endDate)}</Text>
                </TextWrapper>
              </ColumnUnitWrapper>
            </RowUnitWrapper>
          </ColumnUnitWrapper>
          <RowUnitWrapper width='100%' gap='10px'>
            <InnerBox>
              <RowUnitWrapper width='100%' style={{ justifyContent: 'space-between' }}>
                <TextWrapper height='21px'>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.assignModalTransferPeriod')}</Text>
                </TextWrapper>
                <RowUnitWrapper gap='2px'>
                  <TextWrapper height='21px'>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{remainingDays}</Text>
                  </TextWrapper>
                  <TextWrapper height='21px'>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} cursor='default'>{t('memberDetail.assignModalDaysLeft')}</Text>
                  </TextWrapper>
                </RowUnitWrapper>
              </RowUnitWrapper>
              <RowUnitWrapper width='100%' gap='5px'>
                <Input placeholder='0' value={transferDays} onChange={handleTransferDaysChange} />
                <TextWrapper height='32px'>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('memberDetail.assignModalDaysUnit')}</Text>
                </TextWrapper>
              </RowUnitWrapper>
              <RowUnitWrapper width='100%' gap='10px' style={{ justifyContent: 'flex-end' }}>
                <TextWrapper height='18px'>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('memberDetail.assignModalEndDate')}</Text>
                </TextWrapper>
                <TextWrapper height='18px'>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} cursor='default'>{computeTransferEndDate()}</Text>
                </TextWrapper>
              </RowUnitWrapper>
            </InnerBox>
            <InnerBox>
              <RowUnitWrapper width='100%' style={{ justifyContent: 'space-between' }}>
                <TextWrapper height='21px'>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.assignModalTransferSessions')}</Text>
                </TextWrapper>
                {
                  !isUnlimitedSessions &&
                  <RowUnitWrapper gap={languageMode === 'en' ? '3px' : '0px'}>
                    <TextWrapper height='21px'>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{remainingSessions}</Text>
                    </TextWrapper>
                    <TextWrapper height='21px'>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} cursor='default'>{t('memberDetail.assignModalSessionsLeft')}</Text>
                    </TextWrapper>
                  </RowUnitWrapper>
                }
              </RowUnitWrapper>
              <RowUnitWrapper width='100%' gap='5px'>
                {
                  isUnlimitedSessions ?
                    <StyledInfiniteWrapper>
                      <StyledInfinite />
                    </StyledInfiniteWrapper>
                    :
                    <Input placeholder='0' value={transferSessions} onChange={handleTransferSessionsChange} />
                }
                <TextWrapper height='32px'>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('memberDetail.assignModalSessionsUnit')}</Text>
                </TextWrapper>
              </RowUnitWrapper>
              {
                !isUnlimitedSessions &&
                <RowUnitWrapper width='100%' gap={languageMode === 'en' ? '3px' : '0px'} style={{ justifyContent: 'flex-end' }}>
                  <TextWrapper height='18px'>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{transferSessions || '0'}</Text>
                  </TextWrapper>
                  <TextWrapper height='18px'>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subText} cursor='default'>{t('memberDetail.assignModalSessionsWillBeTransferred')}</Text>
                  </TextWrapper>
                </RowUnitWrapper>
              }
            </InnerBox>
          </RowUnitWrapper>
        </ColumnUnitWrapper>
      )}
    </ExistingView>
  );
}

const ExistingView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: ${props => (props.$hasSelected && !props.$isSearchOpen) ? '15px' : '6px'};
`;

const SearchInputClickWrapper = styled.div`
  width: 100%;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TransfereeListWrapper = styled.div`
  position: relative;

  flex-shrink: 0;
  width: 418px;
  height: 220px;
`;

const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 1;

  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};
`;

const LottieWrapper = styled.div`
  width: 100px;
  height: 100px;
`;

const TransfereeListScroll = styled.div`
  display: flex;
  flex-direction: column;

  box-sizing: border-box;
  width: 418px;
  max-height: 220px;

  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};
  box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.05);

  overflow-x: hidden;
  overflow-y: scroll;

  scrollbar-width: none;

  &::-webkit-scrollbar {
    width: 0;
  }
`;

const TransfereeListItem = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  flex-shrink: 0;
  max-width: 418px;
  max-height: 44px;

  gap: 10px;

  &:last-child {
    border-bottom: none;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.buttonFill};
    }
  }

  transition: background-color 0.2s ease-in-out;
`;

const MemberListProfileBox = styled.div`
  width: 44px;
  height: 44px;

  overflow: hidden;

  & img {
    object-fit: cover;
  }
`;

const ProfileWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const ProfileBox = styled.div`
  width: 42px;
  height: 42px;

  border-radius: 3px;
  overflow: hidden;

  & img {
    object-fit: cover;
  }
`;

const InnerBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 10px;

  box-sizing: border-box;
  width: 207.5px;
  min-height: 111px;

  gap: 10px;

  border-radius: 10px;
  background-color: ${props => props.theme.background};
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
`;

const ColumnUnitWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  ${props => props.width && `width: ${props.width};`}

  gap: ${props => props.gap};
`;

const RowUnitWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  ${props => props.width && `width: ${props.width};`}

  gap: ${props => props.gap};
`;

const Input = styled.input`
  padding: 0 10px;

  box-sizing: border-box;
  width: 100%;
  height: 32px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  outline: none;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};
  background-color: ${props => props.theme.background};

  &::placeholder {
    color: ${props => props.theme.line};
  }
`;

const StyledInfiniteWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 170.5px;
  height: 32px;
`;

const StyledInfinite = styled(InfiniteSvg)`
  width: auto;
  height: 8px;

  & path {
    fill: ${props => props.theme.text};
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  ${props => props.width && `width: ${props.width};`}
  height: ${props => props.height};
`;

const Text = styled.div`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;
